import { tourStatusUtils } from '@/features/dashboard/tours/types/TourStatus.utils.ts';
import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';
import StatusDot from '@/components/ui/StatusDot.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

const TourStatusIndicator = ({ status }: { status: TourStatus }) => {
  return (
    <Tooltip>
      {/* `StatusDot` nie przekazuje refa, więc wyzwalacz potrzebuje własnego opakowania. */}
      <TooltipTrigger asChild>
        <span className="cursor-default">
          <StatusDot
            tone={tourStatusUtils.getTone(status)}
            label={tourStatusUtils.getLabel(status)}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent>{tourStatusUtils.getTooltip(status)}</TooltipContent>
    </Tooltip>
  );
};

export default TourStatusIndicator;
